export const generateFormsPayload = (data, questions) => {
	const fieldPhone = questions.find(
		(item) => item.question === `Teléfono` || item.question === `Telefono`
	);

	const result = questions.reduce((acc, item) => {
		if (data[item._id]) {
			acc.push({
				question: item.question,
				answer:
					item._id === fieldPhone?._id
						? `+${data[item._id]}`
						: data[item._id],
			});
		} else {
			acc.push({
				question: item.question,
				answer: "",
			});
		}

		return acc;
	}, []);

	return result;
};

export const generateDefaultFormsPayload = (user) => {
	if (!user) return;
	const result = [];
	const keys = Object.keys(user);
	keys.forEach((el) => {
		if (el === "phone" || el === "email" || el === "name") {
			return result.push({ question: el, answer: user[el] });
		}
	});

	const payload = {
		forms: { type: "office", questions: result },
	};
	return payload;
};

export const generateCustomerFormsData = (data) => {
	console.log("Data");
};
